"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonLabel = exports.PersonLabelDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entities_1 = require("../../hooks/use-entities");
var router_1 = require("@reach/router");
exports.PersonLabelDefaultProps = {
  inverted: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PositionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    text-decoration: none;\n    font-weight: 500;\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    text-decoration: none;\n    font-weight: 500;\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.COLOR('light'), theme_1.theme.COLOR('dark'))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LinkStyles)
});
var OrganisationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n  "], ["\n    ", ";\n    display: flex;\n  "])), LinkStyles)
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Name: (0, styled_components_1.default)(router_1.Link)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Position: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  Organisation: (0, styled_components_1.default)(router_1.Link)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles)
};
var PersonLabel = function (props) {
  var className = props.className,
    entity = props.entity,
    inverted = props.inverted;
  var entities = (0, use_entities_1.useEntities)();
  var name = entity.name,
    slug = entity.slug,
    position = entity.position,
    organisation = entity.organisation;
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Name, {
    to: entities.Person.to(slug)
  }, name), position && React.createElement(My.Position, null, position), entities.Organisation && organisation && React.createElement(My.Organisation, {
    to: entities.Organisation.to(organisation.slug)
  }, organisation.name));
};
exports.PersonLabel = PersonLabel;
exports.PersonLabel.defaultProps = exports.PersonLabelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;